import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { USWDSCheckboxComponent } from "./checkbox.component";


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    USWDSCheckboxComponent
  ],
  exports: [
    USWDSCheckboxComponent
  ]
})
export class USWDSCheckboxModule {}
